export const CategoryTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: this.$t('name'),
                    type: 'text',
                    key: 'name',

                },
                {
                    title: this.$t('code'),
                    type: 'text',
                    key: 'code',

                },

            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}